import { render, staticRenderFns } from "./AssignAliasModal.vue?vue&type=template&id=04e7b7af"
import script from "./AssignAliasModal.vue?vue&type=script&lang=js"
export * from "./AssignAliasModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports